


















































































import Vue from 'vue';
import Component from 'vue-class-component';
import _ from 'lodash';
import { Refs } from '@/types';
import { Getter } from 'vuex-class';
import { mapActions } from 'vuex';

import { ValidationRule } from '@cnamts/vue-dot/src/rules/types';
import { requiredFn } from '@cnamts/vue-dot/src/rules/required';
import { deletePrescription, deleteInjection } from '@/services/api/save/api';
import { MotifSuppression } from './types';
import { InfosPSBEN } from '@/store/infosPSBEN/types';
import { ParametresUtilisateur } from '@/store/parametresUtilisateur/types';
import { InfosDelegation } from '../MesParametres/ParametresVaccination/ParametresDelegation/types';
import { InjectionType, VaccinationFolder } from '@/store/folder/types';

const Props = Vue.extend({
	props: {
		openPopInDelAvailable: {
			type: Boolean,
			default: false
		},
		prescriptionId: {
			type: Number,
			required: true
		},
		injectionId: {
			type: Number,
			default: null
		}
	}
});

@Component({
	model: {
		prop: 'openPopInDelAvailable',
		event: 'change'
	},
	methods: {
		...mapActions('globalState', ['addLoading', 'removeLoading']),
		...mapActions('motifsSuppression', ['loadMotifsSuppression'])
	}
})
export default class PopinDelAvailable extends Props {
	@Getter('infosPSBEN/getInfosPSBEN') getInfosPSBEN!: InfosPSBEN | undefined;
	@Getter('parametresUtilisateur/getParametresUtilisateur') parametresUtilisateur!: Map<string, ParametresUtilisateur>;
	@Getter('infosVaccinationFolder/getVaccinationFolder') folder!: VaccinationFolder | undefined;
	@Getter('infosVaccinationFolder/getInjections') injections!: InjectionType[];
	@Getter('motifsSuppression/getListMotifsSuppression') listMotifsSuppression!: MotifSuppression[];

	$refs!: Refs<{
		deleteForm: HTMLFormElement;
	}>;

	motifIdSelected: any | undefined = null;
	psDelegation: InfosDelegation | undefined = undefined;
	isError = false;
	errorCode = '';

	requiredfield: ValidationRule[] = [
		requiredFn({ default: 'Ce champ est obligatoire.' })
	];

	get computedValue(): boolean {
		return this.openPopInDelAvailable;
	}

	set computedValue(value: boolean) {
		this.$emit('change', value);
	}

	cleanError() {
		this.errorCode = '';
		this.isError = false;
	}

	get hasErrorCode() {
		return !_.isNil(this.errorCode) && this.errorCode !== '';
	}

	goToIdentification(): void {
		this.$store.dispatch('infosVaccinationFolder/cleanVaccinationFolder');
		this.$router.push({
			name: 'accueil',
			query: Object.assign({}, this.$router.currentRoute.query)
		});
	}

	get isPrescription(): boolean {
		return _.isNull(this.injectionId);
	}

	get injection(): InjectionType | undefined {
		return _.find(this.injections, { injectionId: this.injectionId });
	}

	get messageInjection(): string {
		const rangVaccinal = this.injection!.rangVaccinal;
		if (rangVaccinal === 1) {
			return '1ère vaccination';
		} else if (rangVaccinal >= 2) {
			return rangVaccinal.toString() + 'ème vaccination';
		} else {
			return 'vaccination';
		}
	}

	deletePrescription() {
		if (this.$refs.deleteForm.validate()) {
			this.addLoading();
			this.cleanError();
			deletePrescription(
				this.folder?.numeroBon,
				this.prescriptionId,
				this.motifIdSelected,
				this.psDelegation
			)
			.then((response) => {
				const errorCode = _.get(response, 'data.value.errorCode');
				this.removeLoading();
				if (_.isNull(errorCode)) {
					this.goToIdentification();
				} else {
					this.errorCode = errorCode;
					this.isError = true;
				}
			})
			.catch((error) => {
				this.isError = true;
				this.removeLoading();
			});
		}
	}

	deleteInjection() {
		if (this.$refs.deleteForm.validate()) {
			this.addLoading();
			this.cleanError();
			const isInjectionSupplementaire = this.injection?.injectionSupplementaire;
			deleteInjection(
				this.folder?.numeroBon,
				this.prescriptionId,
				this.injectionId,
				this.motifIdSelected,
				this.psDelegation
			)
			.then((response) => {
				const errorCode = _.get(response, 'data.value.errorCode');
				this.removeLoading();
				if (_.isNull(errorCode)) {
					this.$store.dispatch('infosVaccinationFolder/updateFolderAndFlags', response);
					this.$emit('onDeleteVaccination', isInjectionSupplementaire);
				} else {
					this.errorCode = errorCode;
					this.isError = true;
				}
			})
			.catch((error) => {
				this.isError = true;
				this.removeLoading();
			});
		}
	}

	reset() {
		this.cleanError();
		this.motifIdSelected = null;
		if (this.$refs.deleteForm) {
			this.$refs.deleteForm.reset();
		}
	}

	created() {
		const parametresUtilisateur =
				this.parametresUtilisateur.get(_.get(this.getInfosPSBEN, 'ps.numRPPS')) as ParametresUtilisateur;
		this.psDelegation = _.get(parametresUtilisateur, 'delegation');
		this.addLoading();
		this.loadMotifsSuppression().finally(() => this.removeLoading());
	}
}
